import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const ChunkyRibKnitRed = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.ChunkyRibKnitRed.itemName}
      name={AW23.tops.ChunkyRibKnitRed.itemName}
      price={AW23.tops.ChunkyRibKnitRed.itemPrice}
      fabric={AW23.tops.ChunkyRibKnitRed.itemFabric}
      src={AW23.tops.ChunkyRibKnitRed.sizeChart}
      divId={AW23.tops.ChunkyRibKnitRed.shopifyDivId}
      mainId={AW23.tops.ChunkyRibKnitRed.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.ChunkyRibKnitRed.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.ChunkyRibKnitRed.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default ChunkyRibKnitRed;
